import type { Record } from 'pkg/api/models/record';

export enum PayoutType {
	Unknown = 0,
	Deposit,
	Fee,
	Chargeback,
	Void,
	Refund,
	CaptureReversal,
	ChargebackReversal,
}

export interface Payout extends Record {
	groupId: number;
	paymentProviderId: string;
	amount: number;
	netAmount: number;
	currency: string;
	type: PayoutType;
	paidOutAt: number;
	accountNumber: string;
}
